import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from 'src/book/src/firebase';
import AlertStyled from 'src/components/pages/AlertStyled';
import { useLanguage } from 'src/LanguageContext';
import { translate } from 'src/translate';
import {
  resetSessionExpiredDialogState,
  setSessionExpiredHandler,
} from 'src/utils/sessionExpired';

export default function SessionExpiredDialog() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { language } = useLanguage();

  const showSessionExpiredDialog = useCallback(() => {
    setOpen(true);
  }, []);

  useEffect(() => {
    setSessionExpiredHandler(showSessionExpiredDialog);
    return () => setSessionExpiredHandler(null);
  }, [showSessionExpiredDialog]);

  const handleAccept = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Failed to sign out after session expiry:', error);
    } finally {
      resetSessionExpiredDialogState();
      navigate('/auth/login');
    }
  };

  return (
    <AlertStyled
      isLoading={false}
      setLoading={() => {}}
      title={translate('sessionExpiredTitle', language)}
      description={translate('sessionExpiredDescription', language)}
      primaryButtonLabel={translate('ok', language)}
      onPrimaryButtonClick={handleAccept}
      open={open}
      setOpen={() => {}}
    />
  );
}
